const lbLocationSelect = angular.module('app.lbLocationSelect', []);

lbLocationSelect.controller('lbLocationSelectCtrl', require('./lbLocationSelectCtrl'));
lbLocationSelect.component('lbLocationSelect', require('./lbLocationSelect'));

export default lbLocationSelect;



// WEBPACK FOOTER //
// ./src/components/lbLocationSelect/index.js